import React, { useEffect, useState } from "react";
import { Box, Button, getColor, InputField, Modal, Typography } from "fds";
import "./index.scss";
import useLoginStore from "../../redux/dispatcher/useLoginStore";
import SuccessIcon from "../../shared/icons/SuccessIcon";
import { useTranslation } from "react-i18next";

interface FindPasswordModalProps {
  open: boolean;
  type?: "link";
  isMobile?: boolean;
  onClose: () => void;
  changeLoading: (status: boolean) => void;
}
const FindPasswordModal: React.FC<FindPasswordModalProps> = ({
  open,
  type,
  isMobile,
  onClose,
  changeLoading,
}) => {
  /** hook 정리 **/
  const { t } = useTranslation();
  const { sendPasswordInit } = useLoginStore();

  /** State 정리 **/
  const [userId, changeUserId] = useState("");
  const [err, setErr] = useState("");
  const [step, changeStep] = useState<"input" | "success">("input");

  /** 함수 정리 **/
  /** 비밀번호를 찾기 전, 사용자 존재 확인 */
  const handleSendFindPasswordRequest = async () => {
    /** error 1 : input 이 없을 경우 */
    if (!userId) {
      setErr(t("login.findPW.userIdPlaceholder"));
    } else {
      changeLoading(true);
      let resp: any = await sendPasswordInit(userId);
      if (resp.payload && resp.payload.code === "success") {
        changeLoading(false);
        setErr("");
        changeStep("success");
      } else {
        changeLoading(false);
        /** error 2 : 존재하지 않는 사용자일 경우 */
        setErr(t("login.findPW.notFoundUser"));
      }
    }
    return;
  };
  return step === "input" ? (
    <Modal
      isMobile={isMobile}
      isExit={!isMobile}
      open={open}
      classes="findPassword"
      onClose={onClose}
      title={
        type === "link" ? t("login.link.forgotPWBtn") : t("login.login.findPW")
      }
      width={540}
      body={
        <Box direction="column">
          <Typography
            type="body2_rg"
            exactColor={getColor(
              isMobile ? "COLOR_TEXT_PRIMARY" : "COLOR_TEXT_SECONDARY"
            )}
          >
            {t("login.findPW.typeUserId")}
          </Typography>
          <InputField
            placeholder={t("login.findPW.userIdPlaceholder")}
            size="md"
            value={userId}
            onChange={(e) => changeUserId(e.target.value)}
            label="Wrapsody eCo ID"
            classes={isMobile ? "mg mt-20" : "mg mt-32"}
            maxLength={64}
            isError={err !== ""}
            helpMessage={err}
            onKeyUp={(e) =>
              e.code === "Enter" && handleSendFindPasswordRequest()
            }
          />
        </Box>
      }
      footer={
        isMobile ? (
          <Box width={"100%"}>
            <Box onClick={onClose}>
              <Typography type="body1_md">{t("common.cancel")}</Typography>
            </Box>
            <Box
              onClick={userId ? handleSendFindPasswordRequest : undefined}
              style={{ cursor: userId ? "pointer" : "not-allowed" }}
            >
              <Typography
                type="body1_md"
                exactColor={getColor(
                  userId
                    ? "COLOR_TEXT_INTERACTIVE_BRAND"
                    : "COLOR_TEXT_INTERACTIVE_BRAND_DISABLED"
                )}
              >
                {t("common.sendMail")}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Box>
            <Button
              btnStyle="fill"
              type="secondary"
              label={t("common.cancel")}
              onClick={onClose}
            />
            <Button
              btnStyle="fill"
              label={t("common.sendMail")}
              onClick={handleSendFindPasswordRequest}
              state={userId ? "default" : "disable"}
            />
          </Box>
        )
      }
    />
  ) : (
    <Modal
      open={open}
      onClose={onClose}
      width={540}
      isCustom={!isMobile}
      height={isMobile ? undefined : 310}
      isMobile={isMobile}
      title={isMobile ? t("login.findPW.sendMail") : undefined}
      bodyMsg={isMobile ? t("login.findPW.checkMailBox") : undefined}
      footer={
        isMobile ? (
          <Box
            onClick={onClose}
            style={{ cursor: "pointer" }}
            width={"100%"}
            height={52}
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              type="body1_md"
              textAlign="center"
              exactColor={getColor("COLOR_TEXT_INTERACTIVE_BRAND")}
            >
              {t("common.confirm")}
            </Typography>
          </Box>
        ) : undefined
      }
    >
      <Box
        direction="column"
        alignItems="center"
        justifyContent="center"
        width={"100%"}
        height={"100%"}
      >
        <SuccessIcon />
        <Typography type="h3" classes="mg mt-24">
          {t("login.findPW.sendMail")}
        </Typography>
        <Typography
          type="body4_rg"
          classes="mg mt-20"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
        >
          {t("login.findPW.checkMailBox")}
        </Typography>
        <Button
          btnStyle="fill"
          label={t("common.confirm")}
          classes="mg mt-32"
          onClick={onClose}
        />
      </Box>
    </Modal>
  );
};
export default FindPasswordModal;
